import { sitesWithSubSites } from '@epicuro-next/utilities';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Site } from 'graphql-api/gql-api-interfaces';

import { sitesFeatureKey } from '../../constants';
import { adapter, currentAccountSites, State } from '../sites.reducer';

export interface SitesState {
  [sitesFeatureKey]: State;
}

export const selectSitesState = createFeatureSelector<State>(sitesFeatureKey);

export const { selectEntities: selectSiteEntities, selectAll: selectSites } =
  adapter.getSelectors(selectSitesState);

export const selectBackground = createSelector(
  selectSitesState,
  (state) => state.background,
);

export const selectSitesLoad = createSelector<SitesState, [State], boolean>(
  selectSitesState,
  (state) => state.loading,
);

export const selectSitesLoaded = createSelector<SitesState, [State], boolean>(
  selectSitesState,
  (state) => state.loaded,
);

export const selectCurrentSite = createSelector<
  SitesState,
  [State],
  Site | null | undefined
>(selectSitesState, (state) => state.currentSite);

export const selectPreLoadedSites = createSelector(
  selectSitesState,
  (state) => state.preloadSites,
);

export const selectPreLoadedAccountSites = createSelector(
  selectSitesState,
  (state: State, accountId: string) => state.preloadSites[accountId],
);

export const selectCurrentAccountSites = createSelector(
  selectSitesState,
  (state) => state[currentAccountSites],
);

export const selectSiteById = (id: string) =>
  createSelector(selectSiteEntities, (entities) => entities[id]);

export const selectAllSites = createSelector(
  selectSitesState,
  (state) => state.allSites,
);

export const selectSitesWithSubSites = createSelector(selectSites, (sites) =>
  sitesWithSubSites(sites ?? []),
);
